// "Remember my selections" persistence. Stores only the contact fields and the
// chosen breed on the device, never the date or time slot (those change every
// visit). Local to the browser only; nothing here is sent to the server except
// as part of a booking the customer actually submits.

const KEY = "radiance.remember.v1";

export interface RememberedSelections {
  dogName: string;
  breed: string;
  ownerName: string;
  phone: string;
  email: string;
}

export function loadRemembered(): RememberedSelections | null {
  try {
    const raw = localStorage.getItem(KEY);
    if (!raw) return null;
    const parsed = JSON.parse(raw) as Partial<RememberedSelections>;
    return {
      dogName: parsed.dogName ?? "",
      breed: parsed.breed ?? "",
      ownerName: parsed.ownerName ?? "",
      phone: parsed.phone ?? "",
      email: parsed.email ?? "",
    };
  } catch {
    // Corrupt or unavailable storage should never break the form.
    return null;
  }
}

export function saveRemembered(value: RememberedSelections): void {
  try {
    localStorage.setItem(KEY, JSON.stringify(value));
  } catch {
    // Private mode or quota errors are non-fatal; the form still works.
  }
}

export function clearRemembered(): void {
  try {
    localStorage.removeItem(KEY);
  } catch {
    // Nothing to recover from here.
  }
}

export function hasRemembered(): boolean {
  try {
    return localStorage.getItem(KEY) !== null;
  } catch {
    return false;
  }
}
